import CheckedIcon from '@mui/icons-material/CheckBox';
import UncheckedIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { Autocomplete, Checkbox, Chip, IconButton, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    addLabelSuggested,
    deleteLabelsAction,
    fetchLabelsAction,
    getLabelsSuggested,
    setLabelsSuggested,
} from 'redux/slices/labelsSlice';
import useStylesLabels from './styles/useStylesLabels.styles';
import useFlexBoxStyles from 'common/flexBox';

const BANNED_CHARS_FOR_LABELS = '.:,;-´¨{}[]`^*+º\\!|"@·#$¢%∞&¬()“=≠\'¡¿?'.split('');

const LabelsInput = (props) => {
    const {
        labels,
        onChange,
        readOnly,
        bannedChars,
        placeholder,
        namespace,
        suggested,
        deleteAction,
        size,
        limitTags,
    } = props;
    const { classes, cx } = useStylesLabels();
    const { classes: flexBox } = useFlexBoxStyles();

    const dispatch = useDispatch();
    const [labelsOptions, setLabelsOptions] = useState(suggested || []);
    const suggestedByNamespace = useSelector(getLabelsSuggested);

    const updateLabels = (_e, labels, action, details) => {
        onChange(labels);
        if (action === 'createOption') {
            dispatch(addLabelSuggested(details.option.trim()));
        }
    };

    useEffect(() => {
        if (namespace) {
            dispatch(setLabelsSuggested([]));
            dispatch(fetchLabelsAction(namespace));
        }
    }, [namespace, dispatch]);

    useEffect(() => {
        if (namespace && suggestedByNamespace?.length > 0) {
            setLabelsOptions(suggestedByNamespace);
        }
    }, [suggestedByNamespace, namespace]);

    const deleteOption = (e, option) => {
        e.stopPropagation();
        e.preventDefault();
        const index = labels.findIndex((l) => l === option);
        if (index !== -1) {
            onChange([...labels.slice(0, index), ...labels.slice(index + 1)]);
        }
        dispatch(deleteLabelsAction(namespace, option));
    };

    let rootClass = classes.root;
    if (size === 'small') {
        rootClass = cx(rootClass, classes.sizeSmall);
    }
    if (size === 'medium') {
        rootClass = cx(rootClass, classes.sizeMedium);
    }

    return (
        <Autocomplete
            limitTags={limitTags || -1}
            className={rootClass}
            disableCloseOnSelect
            multiple
            classes={{
                option: classes.option,
                listbox: classes.listBox,
            }}
            readOnly={readOnly}
            options={labelsOptions}
            value={labels}
            freeSolo
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip key={index} variant="outlined" label={option} {...getTagProps({ index })} />
                ))
            }
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    <Checkbox
                        icon={<UncheckedIcon fontSize="small" />}
                        checkedIcon={<CheckedIcon fontSize="small" />}
                        className={flexBox.marginRight1}
                        checked={selected}
                    />
                    {option}
                    <div className={flexBox.grow1}></div>
                    {deleteAction && (
                        <IconButton
                            onClick={(e) => deleteOption(e, option)}
                            classes={{
                                root: classes.buttonIcon,
                                disabled: classes.buttonIconDisabled,
                            }}
                            size="large"
                        >
                            <VisibilityOffOutlinedIcon className={classes.action} />
                        </IconButton>
                    )}
                </li>
            )}
            // disableClearable={true}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    placeholder={labels.length ? '' : placeholder}
                    onKeyPress={(e) => {
                        if (bannedChars && BANNED_CHARS_FOR_LABELS.includes(e.key)) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}
                    onKeyUp={(e) => (e.target.value = e.target.value.replace(/ /g, '_'))}
                />
            )}
            onChange={updateLabels}
            autoCorrect="false"
        />
    );
};

export default LabelsInput;
